export const companyFragment = `
  id
  name
  profileImage
`;

export const companyManagedFragment = `
  id
  username
  name
  profileImage
`;


// WEBPACK FOOTER //
// ./app/javascript/fragments/index.js